import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type PaginatedResponse } from './types'
import { type BenchmarkResult } from '../prospects/types'

export function useGetBenchmarks ({
  prospectId,
  quoteId,
  pagination,
}: {
  prospectId: string;
  quoteId: string;
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
}) {
  return useQuery<PaginatedResponse<BenchmarkResult>, GrapeAPIErrorType>({
    queryKey: [
      'prospect',
      prospectId,
      'quote',
      quoteId,
      'benchmarks',
      pagination.pageIndex,
      pagination.pageSize,
    ],
    queryFn: async () => {
      const queryParams: Record<string, any> = {
        'page[number]': pagination.pageIndex.toString(),
        'page[size]': pagination.pageSize.toString(),
      }
      const queryString = new URLSearchParams(queryParams).toString()
      const response = await fetchWithHeaders(
        `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/benchmarks?${queryString}`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
